import {z} from 'zod';

export const LeadQualityEnumSchema = z.enum(['cold', 'warm', 'hot', 'unqualified']);
export type LeadQualityEnum = z.infer<typeof LeadQualityEnumSchema>;
